import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { API } from "../lib/api";

export const thumbUrl = (id, size = "small") => `${API}/templates/${id}/thumbnail?size=${size}&v=3`;

export const TemplatePreviewDialog = ({ template, onClose, onUse, useLabel = "Use this template" }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => setLoaded(false), [template?.id]);
  return (
    <Dialog open={!!template} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-3xl bg-[#0c0e14] border-white/10 p-0 overflow-hidden" data-testid="template-preview-dialog">
        {template && (
          <div className="grid md:grid-cols-[1fr_220px]">
            <div className="relative bg-[#1a1d27] p-4 max-h-[85vh] overflow-auto">
              {!loaded && <div className="absolute inset-0 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-emerald-400" /></div>}
              <img src={thumbUrl(template.id, "large")} alt={template.name} onLoad={() => setLoaded(true)} data-testid="template-preview-large-image"
                className={`w-full rounded shadow-2xl transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`} />
            </div>
            <div className="p-6 flex flex-col">
              <DialogTitle className="font-display text-xl">{template.name}</DialogTitle>
              <DialogDescription className="mt-1 text-xs font-mono uppercase tracking-widest text-slate-500">{template.tag}</DialogDescription>
              <span className="mt-5 h-2 w-12 rounded-full" style={{ background: template.accent }} />
              <p className="mt-5 text-sm text-slate-400">Shown with sample content. Your details flow into this layout automatically.</p>
              {onUse && (
                <Button onClick={() => onUse(template.id)} data-testid="template-preview-use-btn" className="mt-auto rounded-full bg-emerald-500 text-black font-semibold hover:bg-emerald-400 hover:text-black">
                  {useLabel}
                </Button>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
